export const endpoint = '/contact';
